export const quizQuestions = [
  {
    id: 1,
    question: "Bạn muốn thương hiệu của mình truyền tải thông điệp gì?",
    options: [
      { id: "a", text: "Sự chuyên nghiệp và uy tín", value: "professional" },
      { id: "b", text: "Sự sáng tạo và độc đáo", value: "creative" },
      { id: "c", text: "Sự thân thiện và gần gũi", value: "friendly" },
      { id: "d", text: "Sự mạnh mẽ và quyết đoán", value: "strong" }
    ]
  },
  {
    id: 2,
    question: "Lĩnh vực hoạt động chính của bạn là gì?",
    options: [
      { id: "a", text: "Kinh doanh & Khởi nghiệp", value: "business" },
      { id: "b", text: "Sáng tạo nội dung & Marketing", value: "content" },
      { id: "c", text: "Công nghệ & Kỹ thuật", value: "tech" },
      { id: "d", text: "Giáo dục & Đào tạo", value: "education" }
    ]
  },
  {
    id: 3,
    question: "Đối tượng khách hàng mục tiêu của bạn là ai?",
    options: [
      { id: "a", text: "Doanh nghiệp và tổ chức", value: "b2b" },
      { id: "b", text: "Người tiêu dùng cá nhân", value: "b2c" },
      { id: "c", text: "Giới trẻ và sinh viên", value: "youth" },
      { id: "d", text: "Chuyên gia và nhà quản lý", value: "professional" }
    ]
  },
  {
    id: 4,
    question: "Phong cách giao tiếp của bạn là gì?",
    options: [
      { id: "a", text: "Trang trọng và chuyên nghiệp", value: "formal" },
      { id: "b", text: "Năng động và nhiệt huyết", value: "energetic" },
      { id: "c", text: "Thân thiện và hài hước", value: "casual" },
      { id: "d", text: "Truyền cảm hứng và động viên", value: "inspiring" }
    ]
  },
  {
    id: 5,
    question: "Giá trị cốt lõi bạn muốn thể hiện là gì?",
    options: [
      { id: "a", text: "Đổi mới và tiên phong", value: "innovation" },
      { id: "b", text: "Chất lượng và hoàn hảo", value: "quality" },
      { id: "c", text: "Chân thành và minh bạch", value: "authentic" },
      { id: "d", text: "Tốc độ và hiệu quả", value: "efficiency" }
    ]
  },
  {
    id: 6,
    question: "Bạn muốn thương hiệu của mình nghe như thế nào?",
    options: [
      { id: "a", text: "Dễ nhớ và dễ phát âm", value: "memorable" },
      { id: "b", text: "Độc đáo và khác biệt", value: "unique" },
      { id: "c", text: "Chuyên nghiệp và sang trọng", value: "premium" },
      { id: "d", text: "Hiện đại và trẻ trung", value: "modern" }
    ]
  },
  {
    id: 7,
    question: "Màu sắc nào phản ánh tính cách của bạn?",
    options: [
      { id: "a", text: "Xanh dương - Tin cậy và ổn định", value: "blue" },
      { id: "b", text: "Cam/Đỏ - Năng lượng và đam mê", value: "warm" },
      { id: "c", text: "Xanh lá - Tươi mới và phát triển", value: "green" },
      { id: "d", text: "Tím/Vàng - Sáng tạo và cao cấp", value: "luxury" }
    ]
  },
  {
    id: 8,
    question: "Mục tiêu dài hạn của bạn là gì?",
    options: [
      { id: "a", text: "Trở thành chuyên gia hàng đầu", value: "expert" },
      { id: "b", text: "Xây dựng cộng đồng lớn mạnh", value: "community" },
      { id: "c", text: "Tạo ra sản phẩm/dịch vụ độc đáo", value: "product" },
      { id: "d", text: "Truyền cảm hứng cho nhiều người", value: "inspire" }
    ]
  }
];

export const brandSuggestions = {
  professional: {
    title: "Thương Hiệu Chuyên Nghiệp",
    description: "Bạn phù hợp với phong cách thương hiệu chuyên nghiệp, uy tín và đáng tin cậy.",
    tips: [
      "Sử dụng tên thật hoặc kết hợp với chuyên môn của bạn",
      "Chọn font chữ serif hoặc sans-serif hiện đại, dễ đọc",
      "Màu sắc nên là xanh navy, xám đậm hoặc đen",
      "Logo đơn giản, tinh tế với biểu tượng chuyên nghiệp",
      "Tone giọng trang trọng nhưng không cứng nhắc"
    ],
    examples: ["Nguyễn Văn A - Chuyên Gia Marketing", "A.Nguyen Consulting", "VanA Professional"]
  },
  creative: {
    title: "Thương Hiệu Sáng Tạo",
    description: "Bạn có phong cách độc đáo, sáng tạo và không ngại thể hiện cá tính riêng.",
    tips: [
      "Tạo tên độc đáo, có thể là từ ghép hoặc từ mới",
      "Sử dụng font chữ hiện đại, có cá tính",
      "Màu sắc táo bạo: cam, tím, hồng hoặc gradient",
      "Logo sáng tạo với hình ảnh nghệ thuật",
      "Tone giọng tự do, thể hiện cá tính"
    ],
    examples: ["CreativeMinds", "ArtFlow Studio", "ThinkBold"]
  },
  friendly: {
    title: "Thương Hiệu Thân Thiện",
    description: "Bạn muốn tạo kết nối gần gũi và xây dựng mối quan hệ lâu dài với khách hàng.",
    tips: [
      "Tên dễ nhớ, dễ phát âm và gần gũi",
      "Font chữ rounded, mềm mại",
      "Màu sắc ấm áp: cam nhạt, vàng, xanh lá nhạt",
      "Logo đơn giản với biểu tượng thân thiện",
      "Tone giọng gần gũi, như trò chuyện với bạn bè"
    ],
    examples: ["Cùng Bạn Phát Triển", "Friendly Coach", "Your Growth Partner"]
  },
  strong: {
    title: "Thương Hiệu Mạnh Mẽ",
    description: "Bạn thể hiện sự quyết đoán, tự tin và khả năng lãnh đạo.",
    tips: [
      "Tên ngắn gọn, mạnh mẽ và dễ nhớ",
      "Font chữ bold, có trọng lượng",
      "Màu sắc đậm: đỏ, đen, xanh đậm",
      "Logo đơn giản nhưng ấn tượng",
      "Tone giọng tự tin, truyền động lực"
    ],
    examples: ["PowerBrand", "Impact Leader", "Bold Vision"]
  }
};